import { makeDataStore } from '../y/data-store';
import { YId, YFlags } from '../y/types';
import { FPageMetadata } from './f-page';

export type FBuiltinPage = 'event' | 'reviews' | 'signup' | 'past' | 'subscribe' | 'profile' | 'membership' | 'bookings' | 'player' | 'invite' | 'booking' | 'giftcard' | 'giftcard_b2b' | 'redeem_code' | 'venue' | 'event' | 'producer' | 'search' | 'tag' | 'friends' | 'preview_page';

export type FApp = 'home' | 'producer';
export type FRouteTargetType = 'client_redirect' | 'server_redirect' | 'page' | 'builtin';
export type FRouteMatchFlag = 'logged_in' | 'logged_out' | 'subscriptions' | 'no_subscriptions' | 'xavi';

export interface FRoute {
    id: YId;
    app: FApp;
    hosts: string[];
    path: string;
    priority: number;
    is_hidden: boolean;
    is_locked: boolean;
    target_type: FRouteTargetType;
    target_url?: string;
    target_page_id?: YId;
    target_builtin?: FBuiltinPage;
    promo_id?: YId;
    match_flags: YFlags<FRouteMatchFlag>;
    parameters: Record<string, string>;
    page_metadata: FPageMetadata;
}

export const f_routes = makeDataStore('f/routes', 'f/route', (m: FRoute) => m, Object.assign);
